import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import Spinner from '../../../../components/spinner/Spinner';
import SubscoreCategories from './subscoreCategories/SubscoreCategories';
import DecodingProbeDetailsContent from './DecodingProbeDetailsContent';
import './DecodingProbeDetails.scss';

const DecodingProbeDetails = ({ fetchFormData, categoriesOfQuestions, result }) => {
    const { measureSubscores } = result;

    useEffect(() => {
        if (isEmpty(categoriesOfQuestions)) {
            fetchFormData();
        }
    }, []);

    return isEmpty(categoriesOfQuestions) ? (
        <Spinner />
    ) : (
        <>
            <SubscoreCategories subscores={measureSubscores} />
            <div className="container pb-4 decoding-content">
                <DecodingProbeDetailsContent
                    result={result}
                    categoriesOfQuestions={categoriesOfQuestions}
                />
            </div>
        </>
    );
};

DecodingProbeDetails.defaultProps = {
    result: {},
    categoriesOfQuestions: {},
    fetchFormData: () => {},
};

DecodingProbeDetails.propTypes = {
    result: PropTypes.object,
    categoriesOfQuestions: PropTypes.object,
    fetchFormData: PropTypes.func,
};

export default DecodingProbeDetails;
